import React from "react";
import "./bareBandi.scss";
import { Button } from "@mui/material";

const BareBandi = ({bareBandiType, setBareBandiType, submit}) => {
  
  return (
    <>
      {!bareBandiType && (
        <>
          <button
            onClick={() => {
              setBareBandiType("auto");
            }}
            className="notActive button-bareBandi"
          >
            Auto
            <div className="description-bareBandi">
              AI will indicate your music tempo
            </div>
          </button>
          <button
            onClick={() => {
              setBareBandiType("manual");
            }}
            className="button-bareBandi"
          >
            Manual
            <div className="description-bareBandi">
              You will indicate your music tempo
            </div>
          </button>
        </>
      )}
      {bareBandiType === "auto" && (
        <>
          <div className="content-bare-bandi">
            <div className="item-bare-bandi">
            Step 1: indicate your music tempo by this
            </div>
            <div className="item-bare-bandi">
            Step 2: Bare Bandi Your Timeline by clicking on this
            </div>
          </div>
          <Button className="done-bare" onClick={submit}>Done</Button>
        </>
      )}
      {bareBandiType === "manual" && (
        <>
          <div className="content-bare-bandi">
            <div className="item-bare-bandi">
            Step 1: indicate your music tempo by this
            </div>
            <div className="item-bare-bandi">
            Step 2: Bare Bandi Your Timeline by clicking on this
            </div>
          </div>
          <Button className="done-bare" onClick={submit}>Done</Button>
        </>
      )}
    </>
  );
};

export default BareBandi;